import React from 'react'
import './goods.less'
import GoodsOperation from './goods-operation/goods-operation'
import { withRouter } from 'react-router'
function Tips() {
  return <span className="font-8">已抢光</span>
}
@(withRouter as any)
class Goods extends React.Component<any> {
  navToDetail = (id: string) => {
    this.props.history.push({ pathname: `/goods-detail/${id}` })
  }

  render() {
    const goods = Object.assign({}, this.props.goods)
    let Opration
    if (goods.num === '0') {
      Opration = <Tips />
    } else {
      Opration = (
        <GoodsOperation
          goods={goods}
          decrease={this.props.decrease}
          increase={this.props.increase}
        />
      )
    }

    return (
      <div className="shoping-goods">
        <img
          onClick={() => this.navToDetail(goods.goods_id)}
          src={goods.cover}
          alt="anxin.png"
        />
        <div className="text ">
          <div
            onClick={() => this.navToDetail(goods.goods_id)}
            className="text-ell font-7"
          >
            {goods.title}
          </div>
          <div
            onClick={() => this.navToDetail(goods.goods_id)}
            className="text-ell retail font-8"
          >
            零售价： {goods.original_price}
          </div>
          <div className="add-delete font-8">
            <div className="text-ell member-price font-8 font_yellow">
              会员价：{goods.current_price}
            </div>
            {Opration}
          </div>
        </div>
      </div>
    )
  }
}
export default Goods
